import { PushContenus } from '@components/push-contenus/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

type Context = 'realisations-client' | 'cuisine-sur-mesure';

function getData(context: Context): PushContenus {
  switch (context) {
    case 'cuisine-sur-mesure':
      return {
        background: 'white',
        title: {
          text: 'Quelle implantation pour [[ma cuisine ?]]',
          as: 'h2',
        },
        contents: [
          {
            title: 'En I',
            image: imageMock,
            url: '/implantations/i',
          },
          {
            title: 'En L',
            image: imageMock,
            url: '/implantations/l',
          },
          {
            title: 'En U',
            image: imageMock,
            url: '/implantations/u',
          },
          {
            title: 'En Îlot',
            image: imageMock,
            url: '/implantations/ilot',
          },
        ],
      };
    case 'realisations-client':
      return {
        background: 'gray',
        title: {
          text: `Vous reprendrez bien un peu d'inspiration pour [[votre cuisine ?]]`,
          as: 'h2',
        },
        text: 'Modernes, industrielles, scandinaves… Découvrez toutes nos cuisines !',
        contents: [
          {
            title: 'Opale',
            image: imageMock,
            url: '/realisation-client/opale',
          },
          {
            title: 'Family & Co',
            image: imageMock,
            url: '/realisation-client/family-and-co',
          },
          {
            title: 'Coffee',
            image: imageMock,
            url: '/realisation-client/coffee',
          },
          {
            title: 'Indus',
            image: imageMock,
            url: '/realisation-client/indus',
          },
        ],
        cta: {
          label: 'Voir toutes les cuisines',
          url: '/mock-blog-cuisines',
        },
      };
  }
}

export const pushContenusMock = (context: Context): Block<PushContenus> => ({
  type: 'push-contenus',
  data: getData(context),
});
